// @module Tavano.TTVideoImageGallery.TTVideoImageGallery
define('Tavano.TTVideoImageGallery.TTVideoImageGallery.View'
,	[
		'tavano_ttvideoimagegallery_ttvideoimagegallery.tpl'
	
	
	,	'Backbone'
    ]
, function (
		tavano_ttvideoimagegallery_ttvideoimagegallery_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Tavano.TTVideoImageGallery.TTVideoImageGallery.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavano_ttvideoimagegallery_ttvideoimagegallery_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			console.log("options", options)

			// this.model = new TTVideoImageGalleryModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
			this.vidId = options.vidid;
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Tavano.TTVideoImageGallery.TTVideoImageGallery.View.Context
	,	getContext: function getContext()
		{
			console.log("this", this)
			//@class Tavano.TTVideoImageGallery.TTVideoImageGallery.View.Context
			return {
				videoId: this.vidId
			};
		}
	});
});
